import React, {useEffect, useState, useLayoutEffect} from 'react';
import {matchPath, Link, useLocation} from 'react-router-dom';
import {ToastContainer} from 'react-toastify';
// import CookieConsent from "react-cookie-consent";

// import Custom Components
import Header from './common/header';
import Footer from './common/footer';
import MobileMenu from './common/mobile-menu';
// import AddToCartModal from './features/modal/add-to-cart-modal';

// import Data
import OverlayPaths from '../mock-data/data.json';

// import Utils
import {init} from '../utils';

// import Style For React
import 'react-image-lightbox/style.css';

function Layout(props) {

    let matchedCount = 0;
    let location = useLocation();
    const [prevPath, setPrevPath] = useState('');

    useLayoutEffect(() => {
        let overlayFlag = true;

        for (let i = 0; i < OverlayPaths.innerOverlayPaths.length; i++) {
            if (prevPath.indexOf(OverlayPaths.innerOverlayPaths[i]) > 0 && location.pathname.indexOf(OverlayPaths.innerOverlayPaths[i]) > 0) {
                overlayFlag = false;
            }

            if (prevPath === location.pathname) {
                overlayFlag = false;
            }
        }

        if (overlayFlag) {
            document.querySelector('body').classList.remove('loaded');
        }
    }, [window.location.pathname])

    useEffect(() => {
        setPrevPath(location.pathname);
        document.querySelector('body').classList.add('loaded');

        // setTimeout(() => {
        //   document.querySelector('body').classList.add('loaded');
        // }, 200);
    }, [window.location.pathname])

    useEffect(() => {

        init();
        // show 404 page — Layout expects <Routes> as direct child (not Suspense).
        const routeNodes = props.children?.props?.children;
        const routes = Array.isArray(routeNodes) ? routeNodes : (routeNodes ? [routeNodes] : []);

        while (matchedCount < routes.length) {
            const routePath = routes[matchedCount]?.props?.path;
            if (routePath != null && matchPath({ path: routePath, end: true }, location.pathname)) {
                break;
            }
            matchedCount++;
        }

        // if ((matchedCount >= routes.length)) {
        //   window.location = process.env.PUBLIC_URL + "/404";
        // }
    })

    return (
        <div className="page-wrapper">
            <Header/>
            {
                props.children
            }
            <Footer {...props} />
            <MobileMenu/>
            <ToastContainer autoClose={4000} className="toast-container"/>
            {/* <CookieConsent buttonText="Akceptuję" buttonStyle={{backgroundColor: '#ff6a00', color: '#fff'}} style={{backgroundColor: '#002b4f'}}>
        Ten serwis wykorzystuje pliki cookies. Korzystanie z witryny oznacza zgodę na ich zapis lub odczyt według ustawień przeglądarki. <Link to={ `${process.env.PUBLIC_URL}/info/o-ciasteczkach` }>Dowiedz się więcej...</Link>
      </CookieConsent> */}
        </div>
    );
}

export default Layout;